export default __webpack_public_path__ + "static/media/cif-ne.67196ee7.svg";